/*
  Clasp & Bloom – product page additions on top of Bera's theme.js (not in Bera). Loaded by layout/theme.liquid.
  - R2 colour-linked photos: after a variant change the gallery shows only the photos of the selected colour
    (all photos wait in <template data-ns-media-all>; <main-product-form data-media-group> names the colour).
    A colour without its own photo shows only the shared photos, or a placeholder, and the note below the gallery;
    never the photos of the colour shown before (1.4.0, CB02). The sticky bar hides its image for such a colour.
  - R2 sticky bar with variant choice: a variant chosen in the bar is selected in the main form through Bera's own
    <variant-selector>; the bar follows the main form (variant, image, price, button state).
  - The address keeps ?variant= of the chosen variant (Bera stops updating it once a quick view was opened).
  - Zoom: Space opens a photo like Enter does (Bera: Enter only).
  - Concept mode: a product form cannot be submitted while ordering is closed (the buttons are disabled in Liquid).
  - The sticky bar stays above Shopify's cookie banner (fixed to the bottom of the window); on small screens, where
    The theme shows the bar (R2), the back-to-top button moves above it.
  - Reduced motion: product photos and related products change without animation (Theme accessibility addition, as in 1.2.x).
  - Quick view: when the drawer closes, the focus returns to the button that opened it (Bera: page body).
  - Amounts formatted by script follow the visitor's currency with Shopify Markets (1.4.1, CB08).
  - The chosen option values keep aria-checked="true" (Bera's variant-selector resets them all to "false").
  Loaded once for every page, so it also serves Bera's quick view on collection and search pages.
  Bera's variant change replaces <main-product-form>; this file reacts to that replacement. No browser storage.
*/
(function () {
  'use strict';
  if (window.NSProduct) return;
  window.NSProduct = true;

  var qsa = function (sel, root) { return Array.prototype.slice.call((root || document).querySelectorAll(sel)); };

  // Container of one product: the product page (<product-template>) or Bera's quick view (#quickViewContent).
  function containerOf(el) {
    return el.closest('#quickViewContent') || el.closest('product-template');
  }
  function inQuickView(el) {
    return !!el.closest('#quickViewContent');
  }

  /* ---------- Money in the visitor's currency (Markets) ---------- */

  // Clasp & Bloom 1.4.1 (CB08): Bera's cart and sticky-bar scripts format amounts with the shop's money format, which is
  // the store currency. With Shopify Markets the cart and prices are in the visitor's currency (Shopify.currency.active),
  // for example GBP while the store currency is EUR; then the amount is formatted in that currency instead of
  // getting the wrong symbol. Liquid prices ('money' filter) are already in the visitor's currency.
  function wrapMoney() {
    var S = window.Shopify;
    if (!S || typeof S.formatMoney !== 'function' || S.formatMoney.nsWrapped) return;
    var original = S.formatMoney;
    var wrapped = function (cents, format) {
      var base = window.wdtTheme && window.wdtTheme.currencyCode;
      var active = S.currency && S.currency.active;
      if (!base || !active || active === base || typeof Intl === 'undefined') return original.apply(this, arguments);
      var value = parseInt(String(cents).replace('.', ''), 10) / 100;
      var text;
      try {
        text = new Intl.NumberFormat(document.documentElement.lang || 'en', { style: 'currency', currency: active }).format(value);
      } catch (e) {
        return original.apply(this, arguments);
      }
      return format && String(format).indexOf(base) !== -1 ? text + ' ' + active : text;
    };
    wrapped.nsWrapped = true;
    S.formatMoney = wrapped;
  }
  wrapMoney();
  document.addEventListener('DOMContentLoaded', wrapMoney);
  window.addEventListener('load', wrapMoney);

  /* ---------- R2: photos of the selected colour ---------- */

  function setSlides(swiperEl, nodes) {
    if (!swiperEl) return;
    var sw = swiperEl.swiper;
    var wrapper = swiperEl.querySelector('.swiper-wrapper');
    if (sw && typeof sw.removeAllSlides === 'function' && typeof sw.appendSlide === 'function') {
      sw.removeAllSlides();
      sw.appendSlide(nodes);
      sw.update();
    } else if (wrapper) {
      wrapper.textContent = '';
      nodes.forEach(function (n) { wrapper.appendChild(n); });
    }
  }

  function showGroup(container, group) {
    var media = container && container.querySelector('wdt-main-media');
    var tpl = media && media.querySelector('template[data-ns-media-all]');
    if (!tpl || !group || media.getAttribute('data-ns-group') === group) return;
    // First sight of this gallery (page load or a new quick view): the server already rendered this colour
    if (!media.hasAttribute('data-ns-group')) {
      media.setAttribute('data-ns-group', group);
      return;
    }
    var pick = function (sel) {
      var host = tpl.content.querySelector(sel);
      return host ? Array.prototype.slice.call(host.children).filter(function (el) {
        var g = el.getAttribute('data-media-group') || '';
        return g === '' || g === group;
      }).map(function (el) { return el.cloneNode(true); }) : [];
    };
    var slides = pick('[data-ns-slides]');
    var own = slides.some(function (el) { return el.getAttribute('data-media-group') === group; });
    var grouped = !!tpl.content.querySelector('[data-ns-slides] [data-media-group]:not([data-media-group=""])');
    var thumbs = pick('[data-ns-thumbs]');
    if (!slides.length) {
      // no own and no shared photo: a neutral placeholder instead of the previous colour's photos
      slides = pick('[data-ns-placeholder]');
      thumbs = [];
    }
    var note = container.querySelector('[data-ns-colour-note]');
    if (note) note.hidden = own || !grouped;
    var gallery = media.querySelector('.product-media-gallery');
    setSlides(gallery, slides);
    setSlides(media.querySelector('.product-thumbnails'), thumbs);
    media.setAttribute('data-ns-group', group);
    // Show the colour's own first photo (its variant photo), also when shared photos come first
    var sw = gallery && gallery.swiper;
    if (sw && sw.slides) {
      var index = -1;
      sw.slides.forEach(function (slide, i) {
        if (index < 0 && slide.getAttribute('data-media-group') === group) index = i;
      });
      sw.slideTo(Math.max(0, index), 0, false);
    }
  }

  /* ---------- R2: sticky bar ---------- */

  var stickyVariants = null;
  function stickyData() {
    if (stickyVariants) return stickyVariants;
    var json = document.querySelector('#sticky-atc-bar [data-ns-sticky-variants]');
    try { stickyVariants = json ? JSON.parse(json.textContent) : []; } catch (e) { stickyVariants = []; }
    return stickyVariants;
  }

  function syncSticky(form) {
    var bar = document.getElementById('sticky-atc-bar');
    if (!bar || !form) return;
    var input = form.querySelector('input[name="id"]');
    var id = input ? input.value : '';
    var select = bar.querySelector('select.stickySelect');
    if (select && id && select.value !== id) select.value = id;
    var option = select && select.selectedIndex >= 0 ? select.options[select.selectedIndex] : null;
    var image = bar.querySelector('.sticky-product-image');
    if (image && option && id) {
      // a colour without its own or a shared photo has no data-img: hide the image instead of keeping another colour's
      var src = option.getAttribute('data-img');
      var box = image.closest('.cart-image') || image;
      if (src) {
        image.src = src;
        image.srcset = src;
      }
      box.hidden = !src;
    }
    var price = form.querySelector('.price_block .price');
    var target = bar.querySelector('.sticky-product-price');
    if (price && target) target.textContent = price.textContent.trim();
    var main = form.querySelector('#addToCart');
    var add = bar.querySelector('[data-ns-sticky-add]');
    if (main && add) {
      add.disabled = main.disabled;
      add.textContent = main.textContent.trim();
    }
  }

  function bindStickySelect() {
    var select = document.querySelector('#sticky-atc-bar select.stickySelect');
    if (!select || !select.options.length) return;
    select.addEventListener('change', function () {
      var variant = stickyData().filter(function (v) { return String(v.id) === select.value; })[0];
      var form = document.querySelector('product-template main-product-form');
      var selector = form && form.querySelector('variant-selector');
      if (!variant || !selector || typeof selector.getVariantJSON !== 'function') return;
      qsa('.variant-options', selector).forEach(function (list) {
        var want = variant.options[Number(list.getAttribute('data-option-index'))];
        var items = qsa('.variant-option-item', list);
        var item = items.filter(function (li) { return li.getAttribute('data-swatch') === want; })[0];
        if (!item) return;
        if (typeof selector.updateARIAStates === 'function') selector.updateARIAStates(items, item);
        else items.forEach(function (li) { li.classList.toggle('selected', li === item); });
      });
      qsa('select[data-option-index]', selector).forEach(function (sel) {
        sel.value = variant.options[Number(sel.getAttribute('data-option-index'))];
      });
      selector.getVariantJSON();
    });
  }

  /* ---------- after every variant change (Bera replaced <main-product-form>) ---------- */

  // Theme accessibility addition: Bera's variant-selector sets aria-checked="false" on every value when it starts (also on the
  // new form after each variant change), so screen readers never hear the chosen value; the selected one gets it back.
  function fixOptionStates(root) {
    qsa('variant-selector .variant-option-item', root).forEach(function (item) {
      var on = item.classList.contains('selected') ? 'true' : 'false';
      item.setAttribute('aria-checked', on);
      item.setAttribute('aria-selected', on);
    });
  }

  function onForm(form) {
    var container = containerOf(form);
    if (!container) return;
    fixOptionStates(form);
    var group = form.getAttribute('data-media-group');
    if (group) showGroup(container, group);
    if (inQuickView(form)) return;
    var input = form.querySelector('input[name="id"]');
    var id = input ? input.value : '';
    if (id) {
      var url = new URL(window.location.href);
      if (url.searchParams.get('variant') !== id) {
        url.searchParams.set('variant', id);
        window.history.replaceState(window.history.state, '', url.toString());
      }
    }
    syncSticky(form);
  }

  new MutationObserver(function (records) {
    records.forEach(function (record) {
      Array.prototype.forEach.call(record.addedNodes, function (node) {
        if (node.nodeType !== 1) return;
        if (node.nodeName === 'MAIN-PRODUCT-FORM') onForm(node);
        else qsa('main-product-form', node).forEach(onForm);
      });
    });
  }).observe(document.documentElement, { childList: true, subtree: true });

  /* ---------- zoom: Space like Enter ---------- */

  document.addEventListener('keydown', function (event) {
    if (event.key !== ' ' || event.altKey || event.ctrlKey || event.metaKey || event.shiftKey) return;
    var link = event.target.closest && event.target.closest('.photoswipe_lightbox .product__media-list > .swiper-slide > a');
    if (!link || inQuickView(link) || window.pswp) return;
    event.preventDefault();
    link.click();
  });

  /* ---------- concept mode: no product form submits while ordering is closed ---------- */

  var concept = (window.wdtTheme && window.wdtTheme.concept) || {};
  var ordering = (!concept.enabled && concept.purchasingEnabled !== false) || (concept.enabled && concept.cartTesting);
  if (!ordering) {
    document.addEventListener('submit', function (event) {
      var form = event.target;
      if (form && form.matches && form.matches('form[action$="/cart/add"], form.shopify-product-form')) {
        event.preventDefault();
        event.stopImmediatePropagation();
      }
    }, true);
  }

  /* ---------- quick view: focus back to the button that opened it ---------- */

  // Theme accessibility addition (as in 1.2.x): Bera leaves the focus on the page body when the quick view drawer closes.
  var qvTrigger = null;
  document.addEventListener('click', function (event) {
    var button = event.target.closest && event.target.closest('.quick-view-btn');
    if (button) qvTrigger = button;
  }, true);
  function bindQuickViewFocus() {
    var drawer = document.getElementById('quickViewOffcanvas');
    if (!drawer || drawer.hasAttribute('data-ns-focus-return')) return;
    drawer.setAttribute('data-ns-focus-return', '');
    drawer.addEventListener('hidden.bs.offcanvas', function () {
      if (qvTrigger && qvTrigger.isConnected) qvTrigger.focus({ preventScroll: true });
      qvTrigger = null;
    });
  }

  /* ---------- sticky bar above Shopify's cookie banner ---------- */

  // Shopify's cookie banner (Customer Privacy) is fixed to the bottom of the window; the bar stays above it.
  function adjustForConsent() {
    var bar = document.getElementById('sticky-atc-bar');
    if (!bar) return;
    var banner = document.getElementById('shopify-pc__banner');
    var h = 0;
    if (banner) {
      var cs = getComputedStyle(banner);
      var r = banner.getBoundingClientRect();
      if (cs.display !== 'none' && cs.visibility !== 'hidden' && r.height > 0 && r.top < window.innerHeight) h = Math.max(0, window.innerHeight - r.top);
    }
    bar.style.bottom = h ? Math.round(h) + 'px' : '';
    liftToTop();
  }

  // The theme shows the bar also below 781 px (R2); there the back-to-top button moves above it instead of covering it
  function liftToTop() {
    var bar = document.getElementById('sticky-atc-bar');
    var toTop = document.getElementById('to-top');
    if (!bar || !toTop) return;
    var cs = getComputedStyle(bar);
    var shown = bar.classList.contains('show') && cs.visibility !== 'hidden' && cs.display !== 'none';
    if (shown && window.innerWidth <= 780) {
      toTop.style.bottom = Math.round((parseFloat(cs.bottom) || 0) + (parseFloat(cs.marginBottom) || 0) + bar.offsetHeight + 12) + 'px';
    } else toTop.style.bottom = '';
  }

  /* ---------- reduced motion ---------- */

  // Theme accessibility addition (kept from 1.2.x): with 'reduce motion' the product photos and the related products change
  // without animation (Bera: 300 ms fade and 2 s slide).
  var reduced = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)');
  function calmSliders(root) {
    if (!reduced || !reduced.matches) return;
    qsa('.product-media-gallery, .product-thumbnails, product-recommendations [data-swiper-slider]', root).forEach(function (el) {
      if (el.swiper && el.swiper.params) el.swiper.params.speed = 0;
    });
  }

  /* ---------- start ---------- */

  function start() {
    fixOptionStates(document);
    qsa('product-template main-product-form').forEach(function (form) {
      var media = containerOf(form) && containerOf(form).querySelector('wdt-main-media');
      if (media && form.getAttribute('data-media-group')) media.setAttribute('data-ns-group', form.getAttribute('data-media-group'));
    });
    bindStickySelect();
    bindQuickViewFocus();
    adjustForConsent();
    window.addEventListener('resize', adjustForConsent);
    var bar = document.getElementById('sticky-atc-bar');
    if (bar) new MutationObserver(liftToTop).observe(bar, { attributes: true, attributeFilter: ['class', 'style'] });
    new MutationObserver(adjustForConsent).observe(document.body, { childList: true });
    // Bera builds the sliders on DOMContentLoaded and the related products after loading them
    setTimeout(function () { calmSliders(document); }, 0);
    var recs = document.querySelector('product-recommendations');
    if (recs) new MutationObserver(function () { calmSliders(recs); }).observe(recs, { childList: true, subtree: true });
    var qv = document.getElementById('quickViewContent');
    if (qv) new MutationObserver(function () { setTimeout(function () { calmSliders(qv); }, 0); }).observe(qv, { childList: true });
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', start);
  else start();
})();
